import common from './common.json';
import partnerships from './partnerships.json';
import createPartnership from './create-partnership.json';
import editPartnership from './edit-partnership.json';
import partnershipSteps from './partnership-steps.json';
import validation from './validation.json';

export default {
  common,
  partnerships,
  createPartnership,
  editPartnership,
  partnershipSteps,
  validation,
};
